import { makeStyles } from 'tss-react/mui';

const name = 'GroupTab';

export const useGroupTabStyles = makeStyles({ name })(() => ({
  root: {
    '&': {
      height: 30,
      minHeight: 'unset',
      boxShadow: 'none',

      borderRadius: 7, // ex 10,

      fontSize: 14,
      fontWeight: 500,
      lineHeight: '143%',
    },
  },
}));
